import React from "react";
import { Modal, ModalContent } from "storefront/components/ModalV2";
import Authentication, { Props as AuthProps } from "./index";
import styles from "./Modal.module.scss";

export type AuthenticationModalProps = Omit<
  AuthProps,
  "onPhoneVerificationMount"
> & {
  isOpen: boolean;
  onRequestClose: () => void;
};

const AuthenticationModal = ({
  isOpen,
  onSuccess,
  onError,
  onRequestClose,
  currentUser,
  authType,
  verifications,
}: AuthenticationModalProps) => (
  <Modal open={isOpen} onRequestClose={onRequestClose}>
    <ModalContent
      className={styles.authenticationModal}
      aria-labelledby="auth-modal-title"
      aria-describedby={undefined}
    >
      <Authentication
        currentUser={currentUser}
        onSuccess={onSuccess}
        onError={onError}
        authType={authType}
        verifications={verifications}
      />
    </ModalContent>
  </Modal>
);

export default AuthenticationModal;
